import { render, staticRenderFns } from "./schoolinfo.vue?vue&type=template&id=7fd09477&scoped=true"
import script from "./schoolinfo.vue?vue&type=script&lang=js"
export * from "./schoolinfo.vue?vue&type=script&lang=js"
import style0 from "./schoolinfo.vue?vue&type=style&index=0&id=7fd09477&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd09477",
  null
  
)

export default component.exports